
import _ from 'lodash'
import React from 'react'

import { KeyValueChangesSection } from './KeyValueChangesSection'
import { KeyValueSection } from './KeyValueSection'
import { TableChangesSection } from './TableChangesSection'
import { TableSection } from './TableSection'

export class Section extends React.Component {
  render () {
    const { snapshot, sectionId, singleColumn } = this.props
    const section = _.get(snapshot, sectionId)
    const title = _.get(section, 'title')

    const dispatcher = {
      kv: KeyValueSection,
      kvChanges: KeyValueChangesSection,
      tableChanges: TableChangesSection,
      table: TableSection
    }
    const component = dispatcher[_.get(section, 'type')]

    const body = (
      <div className='section'>
        {title ? <h2>{title}</h2> : null}
        {component
          ? React.createElement(component, {
            section,
            singleColumn
          })
          : null}
      </div>
    )

    return component ? body : null
  }
}
